import SampleProfilesReducer from './SampleProfilesReducer';

export default from './SampleProfilesContainer';
export const SampleProfilesReducers = {
  SampleProfilesReducer,
};
